if (!customElements.get('wishlist-button')) {
  class WishlistButton extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'ukbookgram:wishlist';
      this.productId = this.dataset.productId;
      this.button = this.querySelector('.wishlist-button__toggle');
      if (this.button) {
        this.button.addEventListener('click', this.toggle.bind(this));
        this.refresh();
      }
    }

    getWishlist() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return [];
      }
    }

    saveWishlist(list) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(list));
      } catch (e) {
        /* localStorage unavailable - fail silently, button still works this page load */
      }
    }

    isSaved() {
      return this.getWishlist().includes(this.productId);
    }

    refresh() {
      const saved = this.isSaved();
      this.button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      this.classList.toggle('wishlist-button--active', saved);
    }

    toggle(event) {
      event.preventDefault();
      let list = this.getWishlist();
      if (list.includes(this.productId)) {
        list = list.filter((id) => id !== this.productId);
      } else {
        list.push(this.productId);
      }
      this.saveWishlist(list);
      this.refresh();
      this.dispatchEvent(
        new CustomEvent('wishlist:change', {
          bubbles: true,
          detail: { productId: this.productId, saved: list.includes(this.productId) },
        })
      );
    }
  }

  customElements.define('wishlist-button', WishlistButton);
}
